<script>
    import { flags } from '$stores/flags';
</script>

{#if $flags.alert_banner}

    <div class="alert-banner fixed">
        <div class="content">
            {@html $flags.alert_banner.message}
            {#if $flags.alert_banner.show_discount}
                <strong>
                    Use code {$flags.alert_banner.discount_code} for {$flags.alert_banner.discount_value}% off.
                </strong>

            {/if}
        </div>
    </div>
{/if}

<style lang="scss">
    :global(.alert-banner) {
        background-color: #356288;
        color: #fff;
        text-align: center;
        padding: 10px 16px;
        line-height: 1.4;
    }

    :global(.alert-banner.fixed) {
        position: sticky;
        top: 60px;
        left: 0;
        width: 100%;
        z-index: 9;

        @media only screen and (min-width: 869px) {
            top: 50px;
        }
    }

    :global(.alert-banner) .content {
        max-width: 1240px;
        margin: 0 auto;
        word-break: break-word;
    }
</style>

